import { cva as r } from "class-variance-authority";
const t = r(
  "rounded transition-colors duration-200 ease-in-out",
  {
    variants: {
      variant: {
        default: "flex items-center justify-center bg-white border border-solid border-primary-50 text-neutral-90 px-1 hover:bg-primary-50 hover:text-primary",
        button: "border border-solid border-primary-50 bg-white hover:bg-primary-50 flex items-center justify-center"
      },
      size: {
        default: "min-h-8 min-w-8",
        sm: "min-w-6 min-h-6"
      },
      disabled: {
        true: "bg-neutral-0 pointer-events-none border-0 cursor-not-allowed",
        false: ""
      },
      active: {
        true: "bg-primary-100 text-white border border-solid border-primary cursor-default pointer-events-none hover:bg-primary-100 hover:text-white active:bg-primary-100 active:text-white",
        false: ""
      }
    }
  }
);
export {
  t as PaginationLinkVariants
};
//# sourceMappingURL=PaginationLinkVariants.mjs.map
